<template>
    <div class="report-header">
        <div class="color-line"></div>

        <div class="report-title">
            <div class="input-container">
                <label for="report-title"><i class="fa fa-pencil"></i></label>
                <input id="report-title" v-model="reportTitleInput" maxlength="50" />
            </div>
        </div>

        <div class="color-line"></div>
    </div>
</template>

<script>
export default {
    name: 'ReportHeader',
    props: {
        reportTitle: {
            type: String,
            required: true
        }
    },
    data: () => ({
        reportTitleInput: ''
    }),
    watch: {
        reportTitleInput(newReportInput) {
            this.$emit('onReportTitleChange', newReportInput)
        },
        reportTitle(newReportTitle) {
            this.reportTitleInput = newReportTitle
        }
    },
    mounted() {
        this.reportTitleInput = this.reportTitle
    }
}
</script>

<style lang="scss" scoped>
$active: $light-3;
$passive: $light;

.report-header {
    padding: 10px 0;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen {
        color: $light-3;
        border-bottom: 1px solid $light-3;
    }
    @media print {
        color: $report-color;
    }

    .report-title {
        flex-grow: 0;

        input {
            width: 30rem; // 480px
            background-color: transparent;
            border: none;
            align-self: center;
            color: $active;
            text-align: left;
            font-weight: 500;

            &:focus ~ label {
                color: $active;
            }

            @media print {
                text-align: center;
                color: $report-color;
                font-weight: bold;
                font-size: 1.875rem; // 30px
            }
        }

        label {
            @media screen {
                color: $passive;
                cursor: pointer;
                margin-bottom: 0;

                &:hover {
                    color: $active;
                }
            }
            @media print {
                display: none;
            }
        }
    }

    .color-line {
        @media screen {
            display: none;
        }
        @media print {
            flex-grow: 1;
            height: 1rem; // 16px
            background-color: $report-color;
        }
    }
}
</style>
